function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import OAuthRedirectBroker from './oauth-redirect';
import NavigateBehavior from '../../views/behaviors/navigate';
/**
 * Chrome for Android will not allow the page to redirect
 * unless its the result of a user action such as a click.
 *
 * Instead of redirecting automatically after confirmation
 * poll, force the user to the /sign(in|up)_complete page
 * where they can click a "continue" button.
 */

let OAuthRedirectChromeAndroidBroker = /*#__PURE__*/function (_OAuthRedirectBroker) {
  _inherits(OAuthRedirectChromeAndroidBroker, _OAuthRedirectBroker);

  var _super = _createSuper(OAuthRedirectChromeAndroidBroker);

  function OAuthRedirectChromeAndroidBroker() {
    _classCallCheck(this, OAuthRedirectChromeAndroidBroker);

    return _super.apply(this, arguments);
  }

  _createClass(OAuthRedirectChromeAndroidBroker, [{
    key: "afterSignInConfirmationPoll",
    value: function afterSignInConfirmationPoll(account) {
      return new NavigateBehavior('signin_confirmed', {
        account,
        continueBrokerMethod: 'finishOAuthSignInFlow'
      });
    }
  }, {
    key: "afterSignUpConfirmationPoll",
    value: function afterSignUpConfirmationPoll(account) {
      return new NavigateBehavior('signup_confirmed', {
        account,
        continueBrokerMethod: 'finishOAuthSignUpFlow'
      });
    }
  }]);

  return OAuthRedirectChromeAndroidBroker;
}(OAuthRedirectBroker);

export default OAuthRedirectChromeAndroidBroker;